export const chat_cross = () => (
  <path
    d="m15 9-6 6m0-6 6 6M21 12a9 9 0 0 1-9 9H3s1.125-1.08 2.659-2.613A9 9 0 1 1 21 12"
    strokeLinecap="round"
    strokeLinejoin="round"
  />
);
